





















































































import Vue from "vue";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";

export default Vue.extend({
  name: "FilterBar",
  components: { NavbarTitle },
  props: {
    should_be_displayed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      classes: "container-d absolute",
      can_be_closed: false
    };
  },
  methods: {
    cleanFilter(): void {
      this.$emit("cleanFilter");
    },
    close(): void {
      this.$emit("close");
      this.can_be_closed = false;
    },
    closeOnOutsideClick(): void {
      if (this.should_be_displayed && this.can_be_closed) this.close();
    }
  },
  watch: {
    should_be_displayed() {
      if (this.should_be_displayed) {
        this.classes = "container-u absolute container-up";
        setTimeout(() => (this.can_be_closed = true), 500);
      } else this.classes = "container-d absolute container-down";
    }
  }
});
